const c = require('./Contract');
const q = require('./Quest');

module.exports = {...c, ...q};